import { Box } from '@chakra-ui/react'
import ManagedDrawer from '@components/common/drawer/managed-drawer'
import ManagedModal from '@components/common/modal/managed-modal'
import OfferBar from '@components/common/offer-bar'
import SereneFooter from '@templates/serene/footer'
import SereneHeader from '@templates/serene/header'
import React from 'react'

const SereneLayout = ({ children }: { children: React.ReactElement }) => {
  return (
    <Box className="flex flex-col min-h-screen">
      <OfferBar />
      <SereneHeader />
      <main
        className="relative flex-grow"
        style={{
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <>{children}</>
      </main>
      <Box mt="8">
        <SereneFooter />
      </Box>
      <ManagedModal />
      <ManagedDrawer />
    </Box>
  )
}

export default SereneLayout
